'use client';

import { createContext } from 'react';

import type { ComboboxRootContextInterface } from '../types/combobox-root.types';

export const ComboboxRootContext = createContext({} as ComboboxRootContextInterface);

ComboboxRootContext.displayName = 'Combobox.Root.Context';
